<!-- 个人签名 -->
<template>
  <div class="container">
    <div v-title>个人签名</div>
    <div v-if="!codeExpired">
      <div class="signature-tip">请进行个人签名</div>
      <div class="esign-container">
        <vue-esign ref="esign" :componentKey="componentKey" v-if="esignShow" :isCrop="isCrop"
          :height='height' class="signature" :lineWidth="lineWidth" :lineColor="lineColor" :isClearBgColor="false"
          :bgColor.sync="bgColor"></vue-esign>
      </div>
      <div class="handle-box">
        <div class="cancel-btn" @click="clearSign">重签</div>
        <div class="submit-btn" @click="submitSign" v-if="!subLoading">确定</div>
        <div class="submit-btn" v-else>提交中</div>
      </div>
    </div>
    <div v-else style="font-size: 16px;padding-top: 200px;">当前二维码已失效，请刷新后扫码</div>

  </div>
</template>
import '../../static/lib/layer.js'
<script>
  export default {
    data() {
      return {
        lineWidth: 6,
        lineColor: '#000000',
        bgColor: '#FFFFFF',
        resultImg: '',
        isCrop: false,
        ccc: '',
        height: 1148,
        componentKey: 0,
        landscape: false,
        token : "",
        id: "",//订单ID
        uid: "",
        codeExpired: false,
        esignShow : true,
        subLoading : false
      };
    },

    components: {},

    computed: {},

    created() {},

    mounted() {
      // window.addEventListener('orientationchange', this.handleOrientationChange);
      // window.addEventListener('resize', this.handleOrientationChange);
      // this.handleOrientationChange()
      if(this.$route.query.token &&  this.$route.query.id){
        this.token = this.$route.query.token
        this.id = this.$route.query.id
        this.uid = this.$route.query.uid
        this.getQrCodestatus()
      }
    },

    methods: {
      handleOrientationChange() {
        if (this.isLandscape()) {
          this.height = 347
           this.componentKey += 1;

            // this.landscape = true
            this.esignShow = false
            this.$nextTick(()=>{

              this.esignShow = true
            })
          console.log('当前是横屏');
        } else {
          // this.height = 1148
           this.landscape = false
           this.esignShow = false
           this.$nextTick(()=>{
             this.esignShow = true
           })
          this.componentKey += 1;
          console.log('当前是竖屏');
        }
      },
      popUp: function(content) {
      	layer.open({
      		content: content,
      		skin: 'msg',
      		time: 2 //2秒后自动关闭
      	});
      },

      isLandscape() {
        return screen.orientation.type.startsWith('landscape');
      },
      clearSign(){
         this.$refs.esign.reset()
      },
      getQrCodestatus(){

        let params = {
          token : this.token
        }
        this.http({
        	url: this.eccpUrl,
        	method: 'get',
          params : params
        }).then(res => {
          if(res.data.code== 10033){
            this.codeExpired = true
            this.popUp(res.data.msg)
          }
          console.log(res)
        }).catch(err=>{
          console.log(err)
        })
      },
      async submitSign(){

        let base64Url = await this.getSignUrl(this.$refs.esign)
        console.log(base64Url,'base')
        if(!base64Url){
          this.popUp('请先签字!')
          return
        }
        // console.log(this.dataURLtoFile(base64Url))
        let file = this.dataURLtoFile(base64Url)
        let fromData = new FormData()
        let signUrl = ""
        this.subLoading = true
        fromData.append('file',file)
        //图片上传
        await this.http({
          url: this.eccpUploadUrl,
          method: "post",
          data: fromData
        }).then(res=>{

          if(res.data.code == 200){
            signUrl = res.data.data
          }else{
            this.subLoading = false
            this.popUp(res.data.msg)
          }
        })
        //签字提交
        let params = {
          signUrl: signUrl,
          id : this.id,
          updateUser: this.uid
        }
        await this.http({
          url : this.signSubmitUrl,
          method : "post",
          data: params
        }).then(res=>{
           console.log(res)
          if(res.data.code == 200){
            layer.open({
              title: '签字完成',
            	content: '请在PC端进行查看确认',
                  btn: ['确定', '取消'],
                  yes: function(index){
                    setTimeout(function() {
                      //这个可以关闭安卓系统的手机
                       document.addEventListener(
                          "WeixinJSBridgeReady",
                          function() {
                             WeixinJSBridge.call("closeWindow");
                          },
                         false
                       );
                        //这个可以关闭ios系统的手机
                       WeixinJSBridge.call("closeWindow");
                    })
                    layer.close(index);
                  }

              })
          }else{
            this.subLoading = false
            this.popUp(res.data.msg)
          }

        }).catch(err=>{
          this.subLoading = false
        })

      },
      // 签字转为base64图片
      getSignUrl(refs) {
        return new Promise((resolve, reject) => {
          refs.generate().then(res => {
            resolve(res)
          }).catch(err => {
            resolve('')
          })
        })
      },
      // 将base64转换为file
      dataURLtoFile(dataurl) {
          let arr = dataurl.split(",");
          let mime = arr[0].match(/:(.*?);/)[1];
          let bytes = atob(arr[1]); // 解码base64
          let n = bytes.length;
          let ia = new Uint8Array(n);
          while (n--) {
            ia[n] = bytes.charCodeAt(n);
          }
          return new File([ia], "easign.jpg", { type: mime });
      },

    }
  }
</script>
<style >
  .container {
    padding: 0.213333rem 0.266667rem 0 0.266667rem;

  }
  .esign-container{
    overflow: hidden;
    border: 1px dashed #AED000;
  }
  .signature{
    width: 100%!important;
  }
  .signature-tip {
    font-weight: 400;
    font-size: 17px;
    color: #262626;
    line-height: 24px;
    text-align: left;
  }
  .handle-box{
    padding-top: 0.32rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.453333rem;
    font-weight: bold;
    text-align: center;
  }
  .handle-box .cancel-btn{
  	width: 4rem;
  	height: 1.173333rem;
  	line-height: 1.173333rem;
  	background: #FFFFFF;
  	color: #8C8C8C;
  	border-radius: 0.106667rem;
    border: 1px solid #D9D9D9;
  }
  .handle-box .submit-btn{
  	width: 4rem;
  	height: 1.173333rem;
  	line-height: 1.173333rem;
  	background: #AED000;
  	color: #FFFFFF;
  	border-radius: 0.106667rem;
  }
  .layui-m-layercont{
    padding: 20px 20px !important;
  }
  .layui-m-layerbtn span[yes] {
    color: #AED000!important;
}
</style>



// WEBPACK FOOTER //
// src/path/signature/signature.vue